import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// ── Global chunk-load error recovery ──
// Catches "Importing a module script failed" from stale browser caches
// and triggers a single automatic reload to fetch the latest asset manifest.
window.addEventListener("error", (event) => {
  const msg = event.message || "";
  if (
    msg.includes("Importing a module script failed") ||
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("error loading dynamically imported module")
  ) {
    const key = "chunk-error-reload-at";
    const last = Number(sessionStorage.getItem(key) || "0");
    const now = Date.now();
    if (now - last > 15_000) {
      sessionStorage.setItem(key, String(now));
      window.location.reload();
    }
  }
});

createRoot(document.getElementById("root")!).render(<App />);

// Prefetch key homepage chunks during idle time so they're ready when user scrolls
if ("requestIdleCallback" in window) {
  requestIdleCallback(() => {
    import("@/components/home/CategoriesSection").catch(() => {});
    import("@/components/home/SpotlightGallery").catch(() => {});
    import("@/components/home/ManufacturerScroll").catch(() => {});
    import("@/components/home/SceneTransition").catch(() => {});
  });
} else {
  setTimeout(() => {
    import("@/components/home/CategoriesSection").catch(() => {});
    import("@/components/home/SpotlightGallery").catch(() => {});
    import("@/components/home/ManufacturerScroll").catch(() => {});
    import("@/components/home/SceneTransition").catch(() => {});
  }, 2000);
}
